"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _rebrand = require("../../icons-react/rebrand");
var NYIcon = 'https://cdn.yc.level.travel/lt-modules-assets/legacy/new-year/new-year.png';
var NYIconMobile = 'https://cdn.yc.level.travel/lt-modules-assets/legacy/new-year/new-year-mobile.png';
var LtLogo = function LtLogo(props) {
  var _props$href = props.href,
    href = _props$href === void 0 ? '/' : _props$href,
    _props$isCompact = props.isCompact,
    isCompact = _props$isCompact === void 0 ? false : _props$isCompact,
    _props$isNewYear = props.isNewYear,
    isNewYear = _props$isNewYear === void 0 ? false : _props$isNewYear,
    _props$className = props.className,
    className = _props$className === void 0 ? isCompact ? 'header-logo-mobile' : 'header-logo' : _props$className;
  var Logo = isCompact ? _rebrand.LogoShortEng : _rebrand.LogoFullEng;
  return /*#__PURE__*/_react["default"].createElement(StyledLtLogo, {
    href: href,
    isCompact: isCompact,
    isNewYear: isNewYear,
    className: className,
    "aria-label": "Logo"
  }, /*#__PURE__*/_react["default"].createElement(Logo, {
    height: "35px"
  }));
};
var StyledLtLogo = _styledComponents["default"].a.withConfig({
  displayName: "LtLogo__StyledLtLogo",
  componentId: "sc-1p52awg-0"
})(["display:inline-block;", ""], function (_ref) {
  var isNewYear = _ref.isNewYear,
    isCompact = _ref.isCompact;
  return isNewYear && "\n    height: 60px;\n    background-image: url(".concat(isCompact ? NYIconMobile : NYIcon, ");\n    background-position: ").concat(isCompact ? 'center' : '21px center', ";\n    background-size: 141px 54px;\n    background-repeat: no-repeat;\n  ");
});
var _default = exports["default"] = LtLogo;